import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'How fast will I feel results?',
    a: 'Most women report feeling noticeably calmer within the first 3 to 5 minutes.'
  }, {
    q: 'Do I need experience with meditation or breathwork?',
    a: 'No. This is designed to be simple and beginner-friendly.'
  }, {
    q: "What if I've already tried everything?",
    a: "That's exactly why this works. It targets your nervous system."
  }, {
    q: 'How much time do I need each day?',
    a: 'Just 5 minutes or less.'
  }, {
    q: 'Is this backed by science?',
    a: 'Yes. Based on nervous system regulation principles.'
  }, {
    q: 'How do I access it?',
    a: 'Immediately after purchase.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-5 bg-white" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <h2 className="font-serif text-3xl md:text-4xl text-charcoal text-center mb-6" data-id="element-15">
          Real Results From Women Who Finally Found Their 'Quiet'
        </h2>
        <div className="mb-10" data-id="element-16">
          <img src="https://cdn.magicpatterns.com/uploads/x6BP6kqMMrvnhawcuGKxYN/Testimonials_screenshots.png" alt="Testimonials from women who used The Nervous System Reset" className="w-full h-auto rounded-2xl shadow-md" data-id="element-17" />
        </div>

        <h2 className="font-serif text-3xl md:text-4xl text-charcoal text-center mb-8" data-id="element-18">
          Frequently Asked Questions
        </h2>

        <div className="space-y-3" data-id="element-19">
          {faqs.map((faq, idx) => <div key={idx} className="border border-sand rounded-2xl overflow-hidden bg-cream" data-id="element-20">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-21">
                <span className="font-medium text-charcoal pr-4" data-id="element-22">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-terracotta transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-23" />
              </button>

              <AnimatePresence data-id="element-24">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-25">
                    <div className="px-6 pb-5 text-charcoal-light" data-id="element-26">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}